import { Button } from "@/components/ui/button";
import { CalendarDays, X } from "lucide-react";

function isoOffset(days) {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + days);
    return d.toISOString().slice(0, 10);
}

function endOfWeekIso() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    // ISO weekday: Mon=1..Sun=7. Push to Sunday.
    const iso = d.getDay() === 0 ? 7 : d.getDay();
    d.setDate(d.getDate() + (7 - iso));
    return d.toISOString().slice(0, 10);
}

/**
 * Quick date-range chips for the Bookings filter.
 * onChange({ date_from, date_to }) is called with the new ISO strings.
 */
export default function QuickDateChips({ value, onChange }) {
    const today = isoOffset(0);
    const tomorrow = isoOffset(1);
    const endWeek = endOfWeekIso();

    const chips = [
        { key: "today", label: "Today", from: today, to: today },
        { key: "tomorrow", label: "Tomorrow", from: tomorrow, to: tomorrow },
        { key: "week", label: "This week", from: today, to: endWeek },
    ];

    function isActive(c) {
        return value?.date_from === c.from && value?.date_to === c.to;
    }

    function apply(c) {
        onChange({ ...value, date_from: c.from, date_to: c.to });
    }

    function clear() {
        onChange({ ...value, date_from: "", date_to: "" });
    }

    const anyActive = chips.some(isActive) || value?.date_from || value?.date_to;

    return (
        <div className="mb-3 flex flex-wrap items-center gap-2" data-testid="quick-date-chips">
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-[#0E2A47]/60">
                <CalendarDays size={12} /> Quick range
            </span>
            {chips.map((c) => {
                const active = isActive(c);
                return (
                    <Button
                        key={c.key}
                        type="button"
                        size="sm"
                        variant="outline"
                        onClick={() => apply(c)}
                        data-testid={`quick-chip-${c.key}`}
                        className={`h-8 rounded-full text-xs font-semibold transition-all ${
                            active
                                ? "border-[#F26B1F] bg-[#FDF1E7] text-[#F26B1F]"
                                : "border-[#ECE4D3] text-[#0E2A47]/80 hover:border-[#0E2A47]"
                        }`}
                    >
                        {c.label}
                    </Button>
                );
            })}
            {anyActive && (
                <Button
                    type="button"
                    size="sm"
                    variant="ghost"
                    onClick={clear}
                    data-testid="quick-chip-clear"
                    className="h-8 rounded-full text-xs text-[#0E2A47]/60 hover:text-[#0E2A47]"
                >
                    <X size={12} className="mr-1" /> Clear
                </Button>
            )}
        </div>
    );
}
